import { Helmet } from 'react-helmet-async';
import { useState, useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  Pagination,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  CircularProgress
} from '@mui/material';

// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import CustomModal from '../components/modal/CustomModal';


// hooks

import { useAxios } from '../context/AxiosHookContext';

// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

// form
import { FormCreateInvitation } from "../components/forms/invitations"
import { useNotification } from '../context/NotificationContext';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Descripción', alignRight: false },
  { id: '' }
];

// ----------------------------------------------------------------------

export default function InvitationsPage() {

  const [open, setOpen] = useState(null);
  const [filterName, setFilterName] = useState('');
  const [openModaOrganizations, setOpenModalOrganizations] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1)
  const [loading, setLoading] = useState(false)
  const [invitationList, setinvitationList] = useState([])
  const [valuesToEdit, setValuesToEdit] = useState({})
  const navigate = useNavigate();


  const INVITATIONS_API = `/invitations?page=${page}&limit=10&description=${filterName}`
  const axios = useAxios();

  const handleOpenMenu = (event, values) => {
    setOpen(event.currentTarget);
    setValuesToEdit(values)
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const getInvitations = useCallback(async () => {
    try {
      setinvitationList([])
      setLoading(true);
      const { data } = await axios.get(INVITATIONS_API);
      setinvitationList(data.data.list);
      setTotalPages(data.data.total_pages)

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [axios, INVITATIONS_API, setinvitationList, setLoading]);


  const newInvitation = () => {
    setValuesToEdit({});
    setOpenModalOrganizations(true);
  }

  useEffect(() => {
    getInvitations();
  }, [getInvitations, filterName])


  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleFilterByName = (event) => {
    setPage(1);
    setFilterName(event.target.value);
  };

  return (
    <>
      <Helmet>
        <title>Invitaciones | {process.env.REACT_APP_APP_NAME} </title>
      </Helmet>


        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Invitaciones
          </Typography>
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={newInvitation}>
            Nueva Invitación
          </Button>
        </Stack>

        <Card>

          <UserListToolbar filterName={filterName} onFilterName={handleFilterByName} />

          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <UserListHead
                headLabel={TABLE_HEAD}
              />
              <TableBody>
                {invitationList?.map((row) =>

                (
                  <TableRow hover key={row._id} tabIndex={-1} role="checkbox" onDoubleClick={() => navigate("/invitationsDetails", { state: row })}>

                    <TableCell component="th" scope="row" padding="normal">
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Typography variant="subtitle2" noWrap>
                          {row.description}
                        </Typography>
                      </Stack>
                    </TableCell>

                    <TableCell align="right">
                      <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                        <Iconify icon={'eva:more-vertical-fill'} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}

              </TableBody>

              {
                loading === true &&
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >

                        <CircularProgress size={"30px"} sx={{ color: "#aa9e97", marginRight: "auto", marginLeft: "auto" }} />

                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              }

              {
                (invitationList.length === 0 && loading === false) &&
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >

                        <Typography variant="h6" paragraph>
                          Sin resultados
                        </Typography>

                        <Typography variant="body2">
                          No se encontraron resultados para
                          <br /> Intente con otra búsqueda.
                        </Typography>
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              }

            </Table>
          </TableContainer>

          <Pagination
            count={totalPages}
            page={page}
            onChange={handleChangePage}

            sx={{ float: "right", margin: 2, color: "#ffe7d9" }}
          />


        </Card>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => { setOpenModalOrganizations(true); setOpen(null) }} >
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Editar
        </MenuItem>

        <MenuItem onClick={() => {  navigate("/invitationsDetails", {state: valuesToEdit }); setOpen(null) }} >
          <Iconify icon={'material-symbols-light:list-alt'} sx={{ mr: 2 }} />
          Invitados
        </MenuItem>
      </Popover>

      <CustomModal
        open={openModaOrganizations}
        modalStyle={{ maxWidth: 800, minWidth: 440 }}
        title={"Formulario de Invitaciones"}
      >
        <FormCreateInvitation
          onClose={() => setOpenModalOrganizations(false)}
          getValues={() => {
            getInvitations();
            setOpenModalOrganizations(false);
            setValuesToEdit({});
            setOpen(null);
          }}
          valuesToEdit={valuesToEdit}
        />
      </CustomModal>
    </>
  );
}
